import type * as ReactRouter from "react-router";
import { AboutPage } from "~/app/components/landing/about-page";
import { getTranslationFn } from "~/app/i18n";

const t = getTranslationFn("en");

export const meta: ReactRouter.MetaFunction = () => [
  { title: t("About.metaTitle") },
  { name: "description", content: t("About.metaDescription") },
];

export default function AboutEN() {
  return <AboutPage locale="en" />;
}
